const tr = {
  // Common
  "app.name": "GrowthRIQ",
  "common.loading": "Yükleniyor...",
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "common.delete": "Sil",
  "common.edit": "Düzenle",
  "common.close": "Kapat",
  "common.back": "Geri",
  "common.next": "İleri",
  "common.previous": "Önceki",
  "common.submit": "Gönder",
  "common.search": "Ara",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.or": "veya",

  // Nav
  "nav.pricing": "Fiyatlandırma",
  "nav.dashboard": "Kontrol Paneli",
  "nav.login": "Giriş",
  "nav.register": "Başla",
  "nav.companies": "Şirketler",
  "nav.advisor": "AI Danışman",
  "nav.admin": "Yönetim",
  "nav.signout": "Çıkış",
  "nav.tools": "Araçlar",
  "nav.blog": "Blog",
  "footer.tools": "Ücretsiz araçlar",
  "footer.blog": "Blog",
  "footer.pricing": "Fiyatlandırma",
  "footer.kvkk": "KVKK",
  "footer.terms": "Şartlar",
  "footer.cookies": "Çerezler",
  "footer.mesafeli": "Mesafeli Satış",
  "footer.onBilg": "Ön Bilgilendirme",

  // Landing
  "landing.hero.label": "YAPAY ZEKA DESTEKLİ BÜYÜME İSTİHBARATI",
  "landing.hero.title": "Önce ölçün, sonra büyüyün.",
  "landing.hero.subtitle": "E-Ticaret ve E-İhracat Stratejinizi Dönüştürün",
  "landing.hero.description": "Önce ölçün, sonra büyüyün. GrowthRIQ; AI görünürlük, rakip analizi, mağaza denetimi, fiyatlama motoru ve dijital olgunluk analizi araçlarınızla e-ticaret büyümenizin tek noktası. 20 dakikada somut yol haritası, anlık skor, kanıt bazlı öneriler.",
  "landing.hero.cta.primary": "Ücretsiz Değerlendirme Başlat",
  "landing.hero.cta.demo": "Örnek Raporu İncele",
  "landing.hero.cta.secondary": "Fiyatları Gör",
  "landing.hero.trust.1": "Kredi kartı gerekmez",
  "landing.hero.trust.2": "5 dakikalık kurulum",
  "landing.hero.trust.3": "TR ve EN destekli",
  "landing.stats.1.value": "100+",
  "landing.stats.1.label": "Stratejik Soru",
  "landing.stats.2.value": "10",
  "landing.stats.2.label": "Analiz Kategorisi",
  "landing.stats.3.value": "<2dk",
  "landing.stats.3.label": "İlk Skoruna Ulaş",
  "landing.stats.4.value": "GPT-5.2",
  "landing.stats.4.label": "Yapay Zeka Modeli",
  "landing.how.label": "NASIL ÇALIŞIR",
  "landing.how.title": "Üç Adımda Stratejinizi Belirleyin",
  "landing.how.1.title": "Sorununuzu Tanımlayın",
  "landing.how.1.desc": "Sektör ve hedefinizi söyleyin. GrowthRIQ size doğru aracı önerir: AI görünürlük, rakip analizi, mağaza denetimi veya kapsamlı olgunluk değerlendirmesi.",
  "landing.how.2.title": "Doğru Aracı Kullanın",
  "landing.how.2.desc": "5 ücretsiz araçla anında iç görü alın ya da 87 soruluk dijital olgunluk değerlendirmesiyle 360° rapor üretin. 2-20 dakika.",
  "landing.how.3.title": "Aksiyon Planını Uygulayın",
  "landing.how.3.desc": "Önceliklendirilmiş 30/60/90 gün aksiyon planı, SWOT/GAP analizi ve AI danışmanla sürekli rehberlik. Anında.",
  "landing.pricing.label": "FİYATLANDIRMA",
  "landing.pricing.title": "Büyümenizle Ölçeklenen Paketler",
  "landing.pricing.free.name": "Ücretsiz",
  "landing.pricing.free.price": "$0",
  "landing.pricing.free.desc": "İlk değerlendirmeniz ücretsiz. Skor + genel bakış raporu.",
  "landing.pricing.basic.name": "E-Ticaret Basic",
  "landing.pricing.basic.price": "$99",
  "landing.pricing.basic.desc": "Detaylı değerlendirme, SWOT, AI sohbet, PDF rapor.",
  "landing.pricing.advanced.name": "E-İhracat Advanced",
  "landing.pricing.advanced.price": "$399",
  "landing.pricing.advanced.desc": "Tüm özellikler, sınırsız değerlendirme, GAP, yol haritası.",
  "landing.pricing.see_all": "Tüm Paketleri Gör",
  "landing.faq.label": "SIKÇA SORULANLAR",
  "landing.faq.title": "Aklınızdaki Sorular",
  "landing.faq.1.q": "Bu platform bir strateji danışmanının yerini tutar mı?",
  "landing.faq.1.a": "Büyük 4 danışmanlık firmalarının yöntemlerini AI ile otomatikleştirdik. Temel stratejik içgörüler için evet — ancak karmaşık M&A ve restructuring projeleri için danışmana ihtiyaç duyabilirsiniz.",
  "landing.faq.2.q": "Değerlendirme ne kadar sürer?",
  "landing.faq.2.a": "Ücretsiz değerlendirme 5-10 dakika. Advanced paketler 20-30 dakika sürer ve 100+ detaylı soru içerir.",
  "landing.faq.3.q": "Teknik bilgi gerekir mi?",
  "landing.faq.3.a": "Hayır. Sorular iş odaklıdır ve jargonsuzdur. Pazarlama, operasyon veya CEO seviyesinde yanıtlanabilir.",
  "landing.faq.4.q": "Verilerim güvende mi?",
  "landing.faq.4.a": "Tüm veriler şifrelenerek saklanır, sadece sizin organizasyonunuz erişebilir. Üçüncü taraflarla paylaşılmaz. KVKK/GDPR uyumlu.",
  "landing.faq.5.q": "İstediğim zaman iptal edebilir miyim?",
  "landing.faq.5.a": "Evet. Aboneliğinizi panelden tek tıkla iptal edebilirsiniz. İade politikası 14 gün içinde geçerlidir.",
  "landing.faq.6.q": "AI benim sektörümü anlıyor mu?",
  "landing.faq.6.a": "Evet. GPT-5.2 tabanlı motor 50+ sektörde eğitildi. Raporlar sektörünüze özel benchmark'lar ve öneriler içerir.",
  "landing.seo.title": "GrowthRIQ — AI Destekli E-Ticaret & E-İhracat Büyüme İstihbaratı",
  "landing.seo.description": "Şirketinizin e-ticaret ve e-ihracat olgunluğunu yapay zeka ile değerlendirin. Stratejik SWOT, GAP analizi ve aksiyon yol haritası alın. İlk değerlendirme ücretsiz.",
  "landing.features.label": "PLATFORM ARAÇLARI",
  "landing.features.title": "Büyümeniz İçin 6 Güçlü Araç, Tek Çatı Altında",
  "landing.feature.1.title": "AI Görünürlük Checkup",
  "landing.feature.1.desc": "ChatGPT, Perplexity ve Gemini gibi AI motorlarda markanızın ne kadar görünür olduğunu ölçer. (ÜCRETSİZ)",
  "landing.feature.2.title": "Rakip Radar",
  "landing.feature.2.desc": "Trendyol, Amazon, Shopify rakiplerinizi anonim olarak karşılaştırın. Boşluk ve fırsatları görün. (ÜCRETSİZ)",
  "landing.feature.3.title": "Rapor Analitik",
  "landing.feature.3.desc": "Marketplace satıcı raporunuzu yükleyin; AI metrikleri yorumlasın, uyarıları çıkarsın. (ÜCRETSİZ)",
  "landing.feature.4.title": "Fiyatlama Motoru",
  "landing.feature.4.desc": "Maliyet, komisyon ve hedef marjla her platform için tavsiye fiyatı anında hesaplayın. (ÜCRETSİZ)",
  "landing.feature.5.title": "Mağaza Denetimi",
  "landing.feature.5.desc": "Kendi sitenizi veya Trendyol/Hepsiburada mağazanızı URL ile analiz edin: teknik, SEO, içerik skorları + hızlı kazanımlar.",
  "landing.feature.6.title": "Dijital Olgunluk Değerlendirmesi",
  "landing.feature.6.desc": "87 soruluk derinlemesine değerlendirme + SWOT/GAP analizi + 30/60/90 gün stratejik yol haritası + AI danışman.",
  "landing.benefits.label": "NEDEN GROWTHRIQ",
  "landing.benefits.title": "Veriye Dayalı Büyüme Kararları",
  "landing.benefit.1": "Dijital stratejinizdeki kritik açıkları tespit edin",
  "landing.benefit.2": "30-90 günlük aksiyon yol haritaları alın",
  "landing.benefit.3": "Sektör standartlarına karşı kıyaslama yapın",
  "landing.benefit.4": "Zaman içinde ilerlemenizi takip edin",
  "landing.benefit.5": "Uzman AI destekli içgörülere erişin",
  "landing.cta.title": "Büyümenizi Hızlandırmaya Hazır Mısınız?",
  "landing.cta.description": "GrowthRIQ ile dijital stratejisini dönüştüren yüzlerce işletmeye katılın.",
  "landing.cta.button": "Ücretsiz Değerlendirmenizi Başlatın",
  "landing.footer": "© 2026 GrowthRIQ. Yapay Zeka Destekli E-Ticaret İstihbarat Platformu.",

  // Login
  "login.title": "Tekrar hoş geldiniz",
  "login.subtitle": "Kontrol panelinize ve değerlendirmelerinize erişmek için giriş yapın.",
  "login.email": "E-posta",
  "login.email.placeholder": "siz@sirket.com",
  "login.password": "Şifre",
  "login.submit": "Giriş Yap",
  "login.submitting": "Giriş yapılıyor...",
  "login.no_account": "Hesabınız yok mu?",
  "login.create_one": "Hesap oluşturun",
  "login.success": "Giriş başarılı",
  "login.error": "Geçersiz e-posta veya şifre",
  "login.stat": "Şirketlerin %87'si GrowthRIQ değerlendirmelerini kullandıktan sonra stratejik netliklerinde iyileşme raporluyor.",

  // Register
  "register.title": "Hesabınızı oluşturun",
  "register.subtitle": "Ücretsiz değerlendirmenizle başlayın.",
  "register.first_name": "Ad",
  "register.last_name": "Soyad",
  "register.email": "E-posta",
  "register.organization": "Organizasyon Adı",
  "register.organization.placeholder": "Şirketiniz A.Ş.",
  "register.password": "Şifre",
  "register.submit": "Hesap Oluştur",
  "register.submitting": "Hesap oluşturuluyor...",
  "register.has_account": "Zaten hesabınız var mı?",
  "register.sign_in": "Giriş yapın",
  "register.success": "Hesap başarıyla oluşturuldu",
  "register.error": "Kayıt başarısız",
  "register.error.email_required": "E-posta adresi girilmedi",
  "register.error.email_invalid": "Geçerli bir e-posta adresi girin",
  "register.error.password_short": "Şifre en az 6 karakter olmalı",
  "register.error.name_required": "Ad ve soyad alanları zorunlu",
  "register.error.org_required": "Şirket adı zorunlu",
  "register.benefit.1": "Dijital olgunluğunuzu değerlendirmek için ücretsiz değerlendirme",
  "register.benefit.2": "AI destekli stratejik içgörüler ve öneriler",
  "register.benefit.3": "30-90 günlük aksiyon yol haritaları",
  "register.benefit.4": "7/24 uzman AI danışman erişimi",
  "register.panel.title": "Büyüme yolculuğunuza bugün başlayın",

  // Dashboard
  "dashboard.welcome": "Tekrar hoş geldiniz, {name}",
  "dashboard.subtitle": "{org} Kontrol Paneli",
  "dashboard.subtitle_default": "Büyüme İstihbarat Kontrol Paneliniz",
  "dashboard.stats.companies": "ŞİRKETLER",
  "dashboard.stats.assessments": "DEĞERLENDİRMELER",
  "dashboard.stats.completed": "TAMAMLANAN",
  "dashboard.stats.avg_score": "ORT. PUAN",
  "dashboard.quick_actions": "Hızlı İşlemler",
  "dashboard.action.add_company": "Şirket Ekle",
  "dashboard.action.chat_advisor": "AI Danışmanla Sohbet",
  "dashboard.action.upgrade": "Planı Yükselt",
  "dashboard.recent": "Son Değerlendirmeler",
  "dashboard.view_all": "Tümünü Gör",
  "dashboard.no_assessments": "Henüz değerlendirme yok",
  "dashboard.start_first": "İlk Değerlendirmenizi Başlatın",
  "dashboard.view_report": "Raporu Gör",
  "dashboard.continue": "Devam Et",

  // Companies
  "companies.title": "Şirketleriniz",
  "companies.subtitle": "Şirketlerinizi yönetin ve yeni değerlendirmeler başlatın.",
  "companies.add": "Şirket Ekle",
  "companies.no_companies": "Henüz şirket eklenmemiş",
  "companies.no_companies_desc": "İlk şirketinizi ekleyerek değerlendirmelere başlayın.",
  "companies.add_first": "İlk Şirketinizi Ekleyin",
  "companies.dialog.title": "Yeni Şirket Ekle",
  "companies.dialog.subtitle": "Şirket bilgilerini girin.",
  "companies.field.name": "Şirket Adı",
  "companies.field.industry": "Sektör",
  "companies.field.country": "Ülke",
  "companies.field.size": "Şirket Büyüklüğü",
  "companies.field.website": "Web Sitesi",
  "companies.field.model": "İş Modeli",
  "companies.field.annual_revenue": "Yıllık Ciro",
  "companies.field.select": "Seçiniz",
  "companies.creating": "Oluşturuluyor...",
  "companies.create": "Şirket Oluştur",
  "companies.start_assessment": "Değerlendirme Başlat",
  "companies.assessments_count": "{count} Değerlendirme",
  "companies.assessment.dialog.title": "Yeni Değerlendirme",
  "companies.assessment.dialog.subtitle": "Değerlendirme türünü ve seviyesini seçin.",
  "companies.assessment.type": "Değerlendirme Türü",
  "companies.assessment.level": "Seviye",
  "companies.assessment.starting": "Başlatılıyor...",
  "companies.assessment.start": "Değerlendirmeyi Başlat",

  // Industries
  "industry.retail": "Perakende ve E-Ticaret",
  "industry.fashion": "Moda ve Giyim",
  "industry.electronics": "Elektronik",
  "industry.food": "Gıda ve İçecek",
  "industry.health": "Sağlık ve Güzellik",
  "industry.home": "Ev ve Bahçe",
  "industry.sports": "Spor ve Outdoor",
  "industry.automotive": "Otomotiv",
  "industry.b2b": "B2B ve Endüstriyel",
  "industry.other": "Diğer",

  // Countries
  "country.us": "Amerika Birleşik Devletleri",
  "country.uk": "Birleşik Krallık",
  "country.de": "Almanya",
  "country.fr": "Fransa",
  "country.tr": "Türkiye",
  "country.nl": "Hollanda",
  "country.es": "İspanya",
  "country.it": "İtalya",
  "country.ca": "Kanada",
  "country.au": "Avustralya",
  "country.other": "Diğer",

  // Business Models
  "model.b2c": "B2C (Tüketiciye)",
  "model.b2b": "B2B (İşletmeye)",
  "model.b2b2c": "B2B2C (Karma)",
  "model.d2c": "D2C (Doğrudan Tüketiciye)",
  "model.marketplace": "Pazar Yeri",

  // Company Sizes
  "size.1-10": "1-10 Çalışan",
  "size.11-50": "11-50 Çalışan",
  "size.51-200": "51-200 Çalışan",
  "size.201-500": "201-500 Çalışan",
  "size.500+": "500+ Çalışan",

  // Assessment Types
  "assessment.type.ecommerce": "E-Ticaret",
  "assessment.type.eexport": "E-İhracat",
  "assessment.level.free": "Ücretsiz",
  "assessment.level.basic": "Temel",
  "assessment.level.advanced": "İleri",

  // Assessment Wizard
  "wizard.title": "Değerlendirme",
  "wizard.loading": "Değerlendirme yükleniyor...",
  "wizard.question": "Soru {current} / {total}",
  "wizard.category": "Kategori: {name}",
  "wizard.critical": "Kritik Soru",
  "wizard.previous": "Önceki",
  "wizard.next": "İleri",
  "wizard.submit": "Değerlendirmeyi Tamamla",
  "wizard.submitting": "Gönderiliyor...",
  "wizard.select_answer": "Lütfen bir cevap seçin",
  "wizard.submit_error": "Cevap kaydedilemedi. Lütfen tekrar deneyin.",
  "wizard.submit_confirm": "Değerlendirmeyi tamamlamak istediğinizden emin misiniz?",
  "wizard.completed": "Değerlendirme tamamlandı!",
  "wizard.report_pending": "Rapor üretiliyor — birkaç saniye içinde hazır olacak.",
  "wizard.complete_error": "Değerlendirme tamamlanamadı. Lütfen tekrar deneyin.",
  "report.generating.title": "AI raporunuz hazırlanıyor...",
  "report.generating.body": "Skorlarınız hazır! Detaylı analiz (SWOT, GAP, Yol Haritası) 30-90 saniye içinde otomatik olarak burada görünecek. Bekleyebilirsiniz, sayfa kendiliğinden yenilenir.",

  // Report
  "report.title": "Değerlendirme Raporu",
  "report.back": "Şirketlere Dön",
  "report.download": "PDF İndir",
  "report.downloading": "İndiriliyor...",
  "report.chat_advisor": "Danışmanla Görüş",
  "report.tab.overview": "Genel Bakış",
  "report.tab.categories": "Kategori Analizi",
  "report.tab.swot": "SWOT Analizi",
  "report.tab.roadmap": "Aksiyon Yol Haritası",
  "report.tab.gap": "GAP Analizi",
  "report.overall_score": "Genel Puan",
  "report.executive_summary": "Yönetici Özeti",
  "report.category_scores": "Kategori Puanları",
  "report.strengths": "Güçlü Yönler",
  "report.weaknesses": "Zayıf Yönler",
  "report.opportunities": "Fırsatlar",
  "report.threats": "Tehditler",
  "report.roadmap.immediate": "Acil (0-30 Gün)",
  "report.roadmap.short_term": "Kısa Vade (30-60 Gün)",
  "report.roadmap.medium_term": "Orta Vade (60-90 Gün)",
  "report.gap.current_state": "MEVCUT DURUM",
  "report.gap.desired_state": "HEDEFLENen DURUM",
  "report.gap.description": "Açık Tanımı",
  "report.gap.impact": "İş Etkisi",
  "report.gap.actions": "Kapanış Aksiyonları",
  "report.gap.empty": "GAP analizi AI rapor oluşturulduktan sonra kullanılabilir olacaktır.",
  "report.no_data": "Veri bulunamadı",
  "report.generating": "Rapor oluşturuluyor...",
  "report.generate": "Rapor Oluştur",
  "report.not_found": "Rapor bulunamadı",
  "report.pdf_not_available": "PDF mevcut değil. Lütfen raporu yeniden oluşturun.",
  "report.pdf_success": "PDF başarıyla indirildi",

  // Pricing
  "pricing.label": "FİYATLANDIRMA",
  "pricing.title": "Büyüme Paketinizi Seçin",
  "pricing.subtitle": "Ücretsiz değerlendirme ile başlayın veya premium paketlerimizle gelişmiş AI destekli içgörülere erişin.",
  "pricing.popular": "EN POPÜLER",
  "pricing.one_time": "tek seferlik",
  "pricing.coupon.placeholder": "Kupon kodu",
  "pricing.coupon.apply": "Uygula",
  "pricing.coupon.applied": "Kupon uygulandı",
  "pricing.coupon.invalid": "Kupon geçersiz",
  "pricing.coupon.with_code": "kod ile",
  "pricing.coupon.free_label": "Kupon ile ÜCRETSİZ",
  "pricing.processing": "İşleniyor...",
  "pricing.start_free": "Ücretsiz Başla",
  "pricing.get_started": "Başla",
  "pricing.whats_included": "Neler Dahil",
  "pricing.feature.ai_analysis": "AI Destekli Analiz",
  "pricing.feature.ai_analysis.desc": "GPT-5.2 destekli içgörülerle dijital stratejinizdeki açıkları ve fırsatları tespit edin.",
  "pricing.feature.swot": "SWOT Analizi",
  "pricing.feature.swot.desc": "Kapsamlı güçlü yönler, zayıf yönler, fırsatlar ve tehditler analizi.",
  "pricing.feature.roadmap": "Aksiyon Yol Haritası",
  "pricing.feature.roadmap.desc": "Spesifik önerilerle önceliklendirilmiş 30-90 günlük aksiyon planı.",
  "pricing.feature.benchmark": "Kategori Kıyaslama",
  "pricing.feature.benchmark.desc": "10 anahtar alanda performansınızı sektör standartlarıyla karşılaştırın.",
  "pricing.feature.advisor": "AI Sohbet Danışmanı",
  "pricing.feature.advisor.desc": "Sonuçlarınız ve stratejiniz hakkında belirli sorulara yanıtlar alın.",
  "pricing.feature.pdf": "PDF Raporlar",
  "pricing.feature.pdf.desc": "Ekibinizle paylaşmak için profesyonel raporlar indirin.",
  "pricing.cta.title": "Büyümenizi hızlandırmaya hazır mısınız?",
  "pricing.cta.desc": "Ücretsiz bir değerlendirme ile başlayın ve GrowthRIQ'nun dijital stratejinizi nasıl dönüştürebileceğini görün.",
  "pricing.cta.button": "Ücretsiz Başlayın",
  "pricing.footer": "© 2026 GrowthRIQ. Tüm hakları saklıdır.",

  // Chat Advisor
  "chat.title": "AI Büyüme Danışmanı",
  "chat.description": "Değerlendirme sonuçlarınız, e-ticaret stratejisi veya dijital dönüşüm en iyi uygulamaları hakkında bana her şeyi sorabilirsiniz.",
  "chat.context": "Bağlam:",
  "chat.general": "Genel (Değerlendirme yok)",
  "chat.input_placeholder": "Değerlendirme sonuçlarınız, strateji önerileri veya sektör en iyi uygulamaları hakkında sorun...",
  "chat.suggested.1": "En büyük gelişim alanlarım nelerdir?",
  "chat.suggested.2": "Dijital pazarlama puanımı nasıl artırabilirim?",
  "chat.suggested.3": "Bu hafta uygulayabileceğim hızlı kazanımlar neler?",
  "chat.suggested.4": "Puanlarımı sektör karşılaştırmalarıyla kıyasla",
  "chat.error": "Yanıt alınamadı",

  // Admin
  "admin.title": "Yönetim Paneli",
  "admin.subtitle": "Kullanıcıları, organizasyonları ve AI promptlarını yönetin",
  "admin.users": "Kullanıcılar",
  "admin.organizations": "Organizasyonlar",
  "admin.prompts": "AI Promptlar",
  "admin.table.id": "ID",
  "admin.table.email": "E-posta",
  "admin.table.name": "İsim",
  "admin.table.role": "Rol",
  "admin.table.organization": "Organizasyon",
  "admin.table.admin": "Yönetici",
  "admin.table.plan": "Plan",
  "admin.table.users": "Kullanıcılar",
  "admin.table.companies": "Şirketler",
  "admin.table.created": "Oluşturulma",
  "admin.table.type": "Tür",
  "admin.table.preview": "Önizleme",
  "admin.table.active": "Aktif",
  "admin.table.inactive": "Pasif",

  // Blog admin
  "admin.blog": "Blog",
  "admin.blog.new": "Yeni Yazı",
  "admin.blog.edit": "Düzenle",
  "admin.blog.delete": "Sil",
  "admin.blog.preview": "Önizle",
  "admin.blog.confirmDelete": "Bu yazıyı silmek istediğinize emin misiniz?",
  "admin.blog.deleted": "Yazı silindi",
  "admin.blog.saved": "Yazı kaydedildi",
  "admin.blog.table.slug": "Slug",
  "admin.blog.table.title": "Başlık",
  "admin.blog.table.status": "Durum",
  "admin.blog.table.views": "Görüntülenme",
  "admin.blog.table.date": "Tarih",
  "admin.blog.table.actions": "Aksiyonlar",
  "admin.blog.status.published": "Yayında",
  "admin.blog.status.draft": "Taslak",
  "admin.blog.form.title": "Blog Yazısı",
  "admin.blog.form.slug": "URL Slug (örn: e-ihracat-rehberi)",
  "admin.blog.form.slugHelp": "Yalnızca küçük harf, rakam, tire. Yayınlandıktan sonra değiştirmeyin.",
  "admin.blog.form.titleTr": "Başlık (Türkçe)",
  "admin.blog.form.titleEn": "Başlık (İngilizce)",
  "admin.blog.form.excerptTr": "Özet (Türkçe)",
  "admin.blog.form.excerptEn": "Özet (İngilizce)",
  "admin.blog.form.contentTr": "İçerik Markdown (Türkçe)",
  "admin.blog.form.contentEn": "İçerik Markdown (İngilizce)",
  "admin.blog.form.metaTr": "Meta Açıklama (Türkçe, 150-160 karakter)",
  "admin.blog.form.metaEn": "Meta Açıklama (İngilizce, 150-160 karakter)",
  "admin.blog.form.coverImage": "Kapak Görseli URL",
  "admin.blog.form.tags": "Etiketler (virgülle ayırın)",
  "admin.blog.form.author": "Yazar",
  "admin.blog.form.published": "Yayında",
  "admin.blog.form.previewTab": "Markdown Önizleme",
  "admin.blog.form.save": "Kaydet",
  "admin.blog.form.cancel": "İptal",
  "admin.blog.form.required": "Zorunlu alanları doldurun",
  "admin.blog.empty": "Henüz yazı yok. İlk yazınızı oluşturun.",

  // Blog AI draft
  "admin.blog.ai.button": "AI ile Taslak",
  "admin.blog.ai.title": "AI Blog Taslak Oluşturucu",
  "admin.blog.ai.description": "Kısa bir konu gir, GPT-5.2 SEO-dostu TR+EN markdown yazı + meta + slug üretsin. Kaydet'e basmadan önce gözden geçirip düzenleyebilirsin.",
  "admin.blog.form.dialogHelp": "Markdown editörü ile blog yazınızı oluşturun veya düzenleyin. TR ve EN sekmelerinde iki dilde içerik girebilirsiniz.",
  "admin.blog.ai.topicLabel": "Konu / Yazı Başlığı",
  "admin.blog.ai.topicPlaceholder": "Örn: Shopify vs WooCommerce 2026 karşılaştırması",
  "admin.blog.ai.keywordsLabel": "Anahtar Kelimeler (opsiyonel, virgülle)",
  "admin.blog.ai.help": "Üretim 20-40 saniye sürebilir. Taslak otomatik olarak draft (yayında değil) olarak açılır.",
  "admin.blog.ai.generate": "Üret",
  "admin.blog.ai.generating": "Üretiliyor...",
  "admin.blog.ai.generated": "AI taslağı oluşturuldu — lütfen gözden geçirip kaydedin",
  "admin.blog.ai.failed": "AI taslağı oluşturulamadı",
  "admin.blog.ai.topicRequired": "Konu en az 3 karakter olmalı",

  // Branding settings
  "branding.title": "Markalı PDF Raporu",
  "branding.subtitle": "Raporlarınıza kendi logo, renk ve altbilginizi ekleyin (White-label)",
  "branding.tab": "Marka",
  "branding.brand_name": "Marka Adı",
  "branding.brand_name.help": "Rapor kapağında ve arka kapakta görünür. Boş bırakılırsa 'GrowthRIQ' kullanılır.",
  "branding.logo_url": "Logo URL",
  "branding.logo_url.help": "Önerilen: yatay, şeffaf arkaplan PNG (max 260×70px). Public bir URL olmalı.",
  "branding.primary_color": "Ana Renk (Hex)",
  "branding.primary_color.help": "Rapor başlıklarında ve vurgu öğelerinde kullanılır. Örn: #1E40AF",
  "branding.footer_text": "Altbilgi Metni",
  "branding.footer_text.help": "Rapor arka kapağında görünür. Telif, gizlilik uyarısı vb.",
  "branding.save": "Kaydet",
  "branding.saved": "Marka ayarları kaydedildi",
  "branding.reset": "Varsayılana Döndür",
  "branding.preview": "Önizleme",
  "branding.invalidColor": "Geçersiz hex renk. Örn: #1E40AF",

  // Coupons admin
  "admin.coupons": "Kuponlar",
  "admin.coupons.new": "Yeni Kupon",
  "admin.coupons.edit": "Düzenle",
  "admin.coupons.delete": "Sil",
  "admin.coupons.cancel": "İptal",
  "admin.coupons.save": "Kaydet",
  "admin.coupons.saved": "Kupon kaydedildi",
  "admin.coupons.deleted": "Kupon silindi",
  "admin.coupons.confirm_delete": "Bu kuponu silmek istediğinize emin misiniz? Mevcut kullanım kayıtları korunmayacak.",
  "admin.coupons.empty": "Henüz kupon yok. İlk kuponunuzu oluşturun.",
  "admin.coupons.code": "Kod",
  "admin.coupons.code_required": "Kod en az 2 karakter olmalı",
  "admin.coupons.description": "Açıklama",
  "admin.coupons.discount": "İndirim",
  "admin.coupons.discount_type": "İndirim Tipi",
  "admin.coupons.discount_value": "Değer",
  "admin.coupons.type.percent": "Yüzde (%)",
  "admin.coupons.type.fixed": "Sabit USD",
  "admin.coupons.type.free": "Tamamen Ücretsiz",
  "admin.coupons.free": "ÜCRETSİZ",
  "admin.coupons.packages": "Paketler",
  "admin.coupons.all_packages": "Tüm paketler",
  "admin.coupons.applicable_packages": "Geçerli Paketler",
  "admin.coupons.packages_help": "Hiçbiri seçilmezse tüm paketler için geçerli olur.",
  "admin.coupons.usage": "Kullanım",
  "admin.coupons.max_uses": "Maks. Kullanım Sayısı",
  "admin.coupons.unlimited": "Sınırsız",
  "admin.coupons.expires": "Bitiş",
  "admin.coupons.expires_at": "Son Kullanma Tarihi",
  "admin.coupons.status": "Durum",
  "admin.coupons.active": "Aktif",
  "admin.coupons.inactive": "Pasif",
  "admin.coupons.actions": "İşlemler",
  "admin.coupons.percent_range": "Yüzde 0-100 arası olmalı",

  // Statuses
  "status.completed": "tamamlandı",
  "status.in_progress": "devam ediyor",
  "status.draft": "taslak",

  // Password Reset
  "reset.title": "Şifre Sıfırlama",
  "reset.subtitle": "E-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.",
  "reset.email": "E-posta",
  "reset.submit": "Sıfırlama Bağlantısı Gönder",
  "reset.submitting": "Gönderiliyor...",
  "reset.success": "Sıfırlama bağlantısı gönderildi",
  "reset.new_password": "Yeni Şifre",
  "reset.confirm_submit": "Şifreyi Sıfırla",
  "reset.confirm_success": "Şifreniz başarıyla sıfırlandı",
  "reset.back_login": "Giriş sayfasına dön",
  "reset.check_email": "Bu e-posta kayıtlıysa, sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin.",
  "login.forgot_password": "Şifrenizi mi unuttunuz?",

  // Plan
  "plan.title": "Mevcut Planınız",
  "plan.usage": "Kullanım",
  "plan.assessments": "Değerlendirmeler",
  "plan.companies": "Şirketler",
  "plan.upgrade": "Planı Yükselt",
  "plan.of": "/",

  // Tools — hub
  "tools.nav": "Araçlar",
  "tools.hub.badge": "4 ücretsiz araç • Kayıt gerektirmez",
  "tools.hub.title.line1": "E-ticaret büyüme araçları,",
  "tools.hub.title.highlight": "tek tıkla AI",
  "tools.hub.title.line2": "destekli.",
  "tools.hub.subtitle": "AI görünürlük, rakip analizi, performans raporu ve fiyatlama motoru — hepsi tek çatı altında. Kayıt olmadan deneyin, beğendikçe tam analiz için",
  "tools.hub.subtitle.cta": "GrowthRIQ hesabı açın",
  "tools.hub.upsell.title": "Tüm araçlardan daha derin bir analize hazır mısınız?",
  "tools.hub.upsell.body": "87 soruluk dijital olgunluk değerlendirmesi + AI destekli stratejik rapor + 30/60/90 gün aksiyon planı.",
  "tools.hub.upsell.cta": "Ücretsiz değerlendirmeyi başlat",
  "tools.cards.geo.badge": "AI",
  "tools.cards.geo.title": "AI Görünürlük Checkup",
  "tools.cards.geo.desc": "Markanız ChatGPT, Perplexity ve Gemini gibi AI motorlarda görünür mü? 5 dakikada anlayın.",
  "tools.cards.geo.cta": "Ücretsiz analiz",
  "tools.cards.rakip.badge": "AI",
  "tools.cards.rakip.title": "Rakip Radar",
  "tools.cards.rakip.desc": "Trendyol, Amazon, Shopify rakiplerinizi anonim olarak karşılaştırın. Boşlukları ve fırsatları görün.",
  "tools.cards.rakip.cta": "Rakiplerimi karşılaştır",
  "tools.cards.rapor.badge": "AI",
  "tools.cards.rapor.title": "Rapor Analitik",
  "tools.cards.rapor.desc": "Marketplace satıcı panelinizden indirdiğiniz raporu yükleyin; AI sizin için yorumlasın.",
  "tools.cards.rapor.cta": "Raporumu yükle",
  "tools.cards.fiyat.badge": "Hesaplayıcı",
  "tools.cards.fiyat.title": "Fiyatlama Motoru",
  "tools.cards.fiyat.desc": "Maliyet, komisyon ve hedef kâr girin; her platform için tavsiye satış fiyatını anında hesaplayın.",
  "tools.cards.fiyat.cta": "Hesaplamayı başlat",

  // Tools — shared layout
  "tools.layout.back": "Tüm araçlar",
  "tools.upsell.deeper": "Daha derin bir analiz ister misiniz?",
  "tools.upsell.deeper.body": "87 soruluk dijital olgunluk değerlendirmesi + AI stratejik rapor + aksiyon planı.",
  "tools.upsell.deeper.cta": "Ücretsiz hesap aç",

  // Tools — email capture
  "tools.capture.title": "Sonucu e-posta ile alın",
  "tools.capture.desc": "Sonucunuzu kaydedip referans olarak e-postanıza gönderelim. Reklam yok, sadece raporunuz.",
  "tools.capture.placeholder": "siz@sirketiniz.com",
  "tools.capture.submit": "Sonucu gönder",
  "tools.capture.sending": "Gönderiliyor...",
  "tools.capture.marketing": "Ayda 1 büyüme bülteni almayı kabul ediyorum (istediğim zaman vazgeçebilirim).",
  "tools.capture.invalid": "Geçerli bir e-posta adresi girin",
  "tools.capture.success.delivered": "Sonucunuz e-posta adresinize gönderildi",
  "tools.capture.success.queued": "Sonucunuzu kaydettik",
  "tools.capture.success.title": "Teşekkürler!",
  "tools.capture.success.delivered_body": "Sonucunuzu kısaca {email} adresine ilettik. Spam klasörünü kontrol etmeyi unutmayın.",
  "tools.capture.success.delivered_marketing": "Aylık büyüme ipuçlarımız da yolda.",
  "tools.capture.success.queued_body": "Sonucunuzu {email} adresi ile kaydettik. E-posta gönderim servisimiz birkaç gün içinde aktif olacak.",
  "tools.capture.error": "E-posta gönderilemedi",
  "tools.capture.coupon.title": "🎁 Hoş geldin hediyeniz: 30 günlük %15 indirim",
  "tools.capture.coupon.hint": "Checkout sayfasında kupon alanına yapıştırın. Tüm paketlerde geçerli.",

  // Pricing — legal consent (Türkiye Mesafeli Satış)
  "pricing.legal.preinfo": "Ön Bilgilendirme Formu",
  "pricing.legal.distance": "Mesafeli Satış Sözleşmesi",
  "pricing.legal.and": "ve",
  "pricing.legal.accept": "metinlerini okudum, elektronik ortamda onaylıyorum.",
  "pricing.legal.required": "Lütfen Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi'ni onaylayın.",

  // Tools — geo-checkup
  "tools.geo.title": "AI Görünürlük Checkup",
  "tools.geo.subtitle": "Şirketiniz ChatGPT, Perplexity ve Gemini gibi AI motorlarda görünür mü? Aşağıdaki formu doldurun, 30 saniye içinde detaylı raporu alın.",
  "tools.geo.field.sirket": "Şirket adı",
  "tools.geo.field.url": "Web sitesi URL'i",
  "tools.geo.field.sektor": "Sektör",
  "tools.geo.field.market": "Hedef pazar",
  "tools.geo.field.aciklama": "Şirket hakkında kısa açıklama",
  "tools.geo.field.aciklama.hint": "İsteğe bağlı, ne yaptığınızı 1-2 cümlede anlatın",
  "tools.geo.field.rivals": "Rakipleriniz",
  "tools.geo.field.rivals.hint": "En fazla 5 rakip ekleyebilirsiniz",
  "tools.geo.field.rivals.placeholder": "Rakip adı veya URL",
  "tools.geo.field.rivals.add": "Rakip ekle",
  "tools.geo.submit": "Analizi başlat",
  "tools.geo.submitting": "AI analiz ediyor...",
  "tools.geo.hint.duration": "AI yanıtı ~20-40 saniye sürebilir.",
  "tools.geo.required.sirket": "Şirket adı zorunlu",
  "tools.geo.fail": "Analiz başarısız oldu. Lütfen tekrar deneyin.",
  "tools.geo.result.score": "Genel skor",
  "tools.geo.result.subscores": "Alt skorlar",
  "tools.geo.result.subscore.ai": "AI görünürlük",
  "tools.geo.result.subscore.tech": "Teknik hazırlık",
  "tools.geo.result.subscore.content": "İçerik hazırlık",
  "tools.geo.result.subscore.schema": "Schema",
  "tools.geo.result.subscore.brand": "Marka otoritesi",
  "tools.geo.result.tech": "Teknik bulgular",
  "tools.geo.result.content": "İçerik bulguları",
  "tools.geo.result.brand": "Otorite bulguları",
  "tools.geo.result.wins": "Hızlı kazanımlar",
  "tools.geo.result.critical": "Kritik sorunlar",
  "tools.geo.result.roadmap": "30 / 60 / 90 gün yol haritası",
  "tools.geo.result.roadmap.30": "30 gün",
  "tools.geo.result.roadmap.60": "60 gün",
  "tools.geo.result.roadmap.90": "90 gün",
  "tools.geo.result.impact": "Etki:",

  // Tools — competitor radar
  "tools.comp.title": "Rakip Radar",
  "tools.comp.subtitle": "Mağazanızı ve rakiplerinizin verilerini girin. AI sizin için karşılaştırmalı analiz, içgörü ve aksiyon planı çıkartır.",
  "tools.comp.section.mine": "Senin mağazan",
  "tools.comp.section.rivals": "Rakipler",
  "tools.comp.platform": "Platform",
  "tools.comp.field.name": "Mağaza adı",
  "tools.comp.field.url": "Mağaza URL'i",
  "tools.comp.field.revenue": "Aylık ciro (₺)",
  "tools.comp.field.orders": "Aylık satış adedi",
  "tools.comp.field.rating": "Satıcı puanı",
  "tools.comp.field.cancel": "İptal oranı (%)",
  "tools.comp.field.followers": "Takipçi sayısı",
  "tools.comp.field.products": "Ürün sayısı",
  "tools.comp.field.price": "Ort. ürün fiyatı (₺)",
  "tools.comp.field.shipping": "Kargo süresi (gün)",
  "tools.comp.field.rival.urls": "Rakip URL'leri",
  "tools.comp.field.rival.urls.hint": "En fazla 5 rakip",
  "tools.comp.field.rival.urls.add": "Rakip ekle",
  "tools.comp.hint.rivals": "Aşağıdaki alanlar rakiplerin görünür ortalamaları içindir (varsayım girebilirsiniz).",
  "tools.comp.field.rival.rating": "Rakip puanı (ort.)",
  "tools.comp.field.rival.cancel": "Rakip iptal (%)",
  "tools.comp.field.rival.followers": "Rakip takipçi",
  "tools.comp.field.rival.products": "Rakip ürün sayısı",
  "tools.comp.field.rival.age": "Rakip yaş (ay)",
  "tools.comp.field.rival.price": "Rakip ort. fiyat (₺)",
  "tools.comp.submit": "Karşılaştırmayı başlat",
  "tools.comp.required.name": "Mağaza adı zorunlu",
  "tools.comp.required.rival": "En az 1 rakip URL'i ekleyin",
  "tools.comp.fail": "Analiz başarısız oldu.",
  "tools.comp.result.summary": "Özet",
  "tools.comp.result.strong": "Güçlü yönlerim",
  "tools.comp.result.weak": "Zayıf yönlerim",
  "tools.comp.result.compare": "Karşılaştırma",
  "tools.comp.result.col.criterion": "Kriter",
  "tools.comp.result.col.mine": "Bende",
  "tools.comp.result.col.rival": "Rakipte",
  "tools.comp.result.col.status": "Durum",
  "tools.comp.result.insights": "İçgörüler",
  "tools.comp.result.actions": "Aksiyon listesi",
  "tools.comp.result.impact": "Etki:",

  // Tools — report analytics
  "tools.rapor.title": "Rapor Analitik",
  "tools.rapor.subtitle": "Marketplace satıcı panelinizden indirdiğiniz raporu (CSV / metin) yükleyin veya verileri yapıştırın. AI özetler, fırsatları gösterir.",
  "tools.rapor.platform": "Platform",
  "tools.rapor.files": "Rapor dosyaları",
  "tools.rapor.files.hint": "CSV / TXT formatında, en fazla 5 dosya. Her dosya ilk 8000 karakter kadar analiz edilir.",
  "tools.rapor.files.btn": "Dosya seç (CSV / TXT)",
  "tools.rapor.paste": "Veya verileri yapıştırın",
  "tools.rapor.paste.hint": "Tablo, metin veya kısa özet kabul edilir.",
  "tools.rapor.paste.placeholder": "Örn: Ay: Ekim 2024 — Net ciro: 124.000 TL — Net satış: 520 — İptal oranı: %8,2 — Satıcı puanı: 4,7 ...",
  "tools.rapor.submit": "Raporu analiz et",
  "tools.rapor.fail": "Analiz başarısız oldu.",
  "tools.rapor.required": "Lütfen önce rapor verisini yükleyin veya yapıştırın.",
  "tools.rapor.read_fail": "okunamadı",
  "tools.rapor.strong": "Güçlü yönler",
  "tools.rapor.weak": "Zayıf yönler",
  "tools.rapor.products": "Ürün performansı",
  "tools.rapor.alerts": "Uyarılar",
  "tools.rapor.tasks": "Ödevler",
  "tools.rapor.metric.revenue": "Net ciro",
  "tools.rapor.metric.orders": "Net satış",
  "tools.rapor.metric.cancel": "İptal oranı",
  "tools.rapor.metric.return": "İade oranı",
  "tools.rapor.metric.rating": "Satıcı puanı",
  "tools.rapor.metric.followers": "Takipçi",
  "tools.rapor.metric.basket": "Ort. sepet",
  "tools.rapor.metric.commission": "Komisyon",
  "tools.rapor.col.product": "Ürün",
  "tools.rapor.col.orders": "Satış",
  "tools.rapor.col.revenue": "Ciro",
  "tools.rapor.col.cancel": "İptal %",
  "tools.rapor.col.stock": "Stok",
  "tools.rapor.col.status": "Durum",

  // Tools — pricing
  "tools.fiyat.title": "Fiyatlama Motoru",
  "tools.fiyat.subtitle": "Maliyetlerinizi, komisyonu ve hedef kâr marjını girin. Her platform için tavsiye satış fiyatını ve gerçek net kârı anlık görün.",
  "tools.fiyat.section.costs": "Maliyetler",
  "tools.fiyat.section.targets": "Hedefler",
  "tools.fiyat.section.platforms": "Platformlar",
  "tools.fiyat.section.results": "Tavsiye satış fiyatları",
  "tools.fiyat.currency": "Para birimi",
  "tools.fiyat.product_cost": "Ürün maliyeti",
  "tools.fiyat.shipping_cost": "Kargo maliyeti",
  "tools.fiyat.packaging_cost": "Paketleme",
  "tools.fiyat.marketing_cost": "Pazarlama / Reklam",
  "tools.fiyat.other_cost": "Diğer giderler",
  "tools.fiyat.total": "Toplam birim maliyet:",
  "tools.fiyat.margin": "Hedef kâr marjı (%)",
  "tools.fiyat.margin.hint": "Maliyet üzerine kâr",
  "tools.fiyat.vat": "KDV (%)",
  "tools.fiyat.commission": "Komisyon %",
  "tools.fiyat.no_platform": "En az bir platform seçin.",
  "tools.fiyat.sell_price": "Satış fiyatı",
  "tools.fiyat.net_revenue": "Net gelir",
  "tools.fiyat.net_profit": "Net kâr",
  "tools.fiyat.real_margin": "Gerçek marj:",
  "tools.fiyat.formula": "Hesaplama formülü:",

  // Legal
  "legal.kvkk": "KVKK",
  "legal.terms": "Kullanım Şartları",
  "legal.cookies": "Çerez Politikası",
  "legal.updated": "Son güncelleme:",

  // Cookie banner
  "cookie.title": "Çerezleri kullanıyoruz",
  "cookie.body": "GrowthRIQ çalışması için zorunlu çerezleri kullanır. Detaylar için",
  "cookie.body.link": "Çerez Politikamızı",
  "cookie.body.suffix": "okuyabilirsiniz.",
  "cookie.essential": "Sadece zorunlu",
  "cookie.accept": "Tümünü kabul et",

  // Footer
  "footer.tools": "Ücretsiz araçlar",
  "footer.blog": "Blog",
  "footer.pricing": "Fiyatlandırma",
  "footer.col.product": "Ürün",
  "footer.col.company": "Şirket",
  "footer.col.legal": "Yasal",
  "footer.col.commerce": "Ticaret",
  "landing.footer.tagline": "Yapay zekâ destekli e-ticaret büyüme istihbaratı. Türkiye'de geliştirildi.",
  "landing.footer.payments": "Güvenli ödeme: İyzico · 3D Secure",

  // Getting Started Checklist (Dashboard)
  "checklist.title": "Başlangıç rehberiniz",
  "checklist.title.done": "Tebrikler — kurulum tamamlandı!",
  "checklist.subtitle": "Birkaç dakikada ilk değerini görmek için aşağıdaki adımları takip edin.",
  "checklist.subtitle.done": "GrowthRIQ'i sonuna kadar kullanmaya hazırsınız. Bu kartı kapatabilirsiniz.",
  "checklist.progress": "tamamlandı",
  "checklist.s1.title": "Hesap oluşturuldu",
  "checklist.s1.body": "GrowthRIQ ailesine hoş geldiniz. İlk skorunuza 5 dakika uzaklıktasınız.",
  "checklist.s2.title": "İlk şirketinizi ekleyin",
  "checklist.s2.body": "Sektör, iş modeli ve hedef pazar bilgileri analizin doğruluğunu artırır.",
  "checklist.s2.cta": "Şirket ekle",
  "checklist.s3.title": "Ücretsiz bir aracı deneyin",
  "checklist.s3.body": "GEO Checkup, Rakip Radarı veya Fiyatlama Motoru ile 1 dakikada anlık değer alın.",
  "checklist.s3.cta": "Araçlara git",
  "checklist.s4.title": "Tam değerlendirmeyi tamamlayın",
  "checklist.s4.body": "55 soruluk dijital olgunluk değerlendirmesi — McKinsey kalitesinde stratejik rapor üretir.",
  "checklist.s4.cta": "Değerlendirme başlat",
  "checklist.s5.title": "Stratejik raporunuzu görüntüleyin",
  "checklist.s5.body": "SWOT, kategori skorları ve 30/60/90 günlük yol haritanız hazır olduğunda PDF olarak indirin.",
  "checklist.s5.cta": "Raporu aç",
  "checklist.s6.title": "Premium plana geçin",
  "checklist.s6.body": "Sınırsız değerlendirme, çoklu şirket, gelişmiş raporlar ve öncelikli destek.",
  "checklist.s6.cta": "Planları gör",
  "checklist.demo.title": "Boş bir dashboard sıkıcı, değil mi?",
  "checklist.demo.body": "Tek tıkla örnek bir şirket + tamamlanmış değerlendirme + AI raporu yükleyin. İstediğiniz zaman silebilirsiniz.",
  "checklist.demo.cta": "Demo verisi yükle",
  "checklist.demo.loading": "Yükleniyor…",
  "checklist.demo.success": "Demo verisi yüklendi — dashboard'a göz atın!",
  "checklist.demo.fail": "Demo verisi yüklenemedi. Lütfen tekrar deneyin.",
  "checklist.demo.active": "Demo verisi aktif: Örnek Tekstil A.Ş. — bu, gerçek müşteri verisi değildir.",
  "checklist.demo.remove": "Demo'yu kaldır",
  "checklist.demo.removed": "Demo verisi kaldırıldı.",

  // Onboarding Tour (common controls)
  "tour.step": "Adım",
  "tour.next": "İleri",
  "tour.prev": "Geri",
  "tour.finish": "Anladım, başlayalım",
  "tour.replay": "Tanıtımı tekrar göster",
  "tour.dontShowAgain": "Bu mesajı bir daha gösterme",

  // GEO Checkup tour
  "tour.geo.s1.title": "AI Görünürlük Checkup'a hoş geldiniz",
  "tour.geo.s1.body": "Bu araç, markanızın ChatGPT, Perplexity, Gemini gibi yapay zekâ motorlarında ne kadar görünür olduğunu 5 dakikada analiz eder. Kayıt gerekmez.",
  "tour.geo.s2.title": "1) Şirket bilgilerinizi girin",
  "tour.geo.s2.body": "Şirket adı, sektör ve hedef pazarınızı seçin. Web sitenizin URL'sini girmeniz daha doğru bir analiz sağlar. Kısa bir tanım yazmak da yardımcı olur.",
  "tour.geo.s3.title": "2) En fazla 5 rakip ekleyin (opsiyonel)",
  "tour.geo.s3.body": "Rakiplerinizin alan adlarını girerek karşılaştırmalı görünürlük tablosu alın. Boş bırakırsanız sadece kendi mağazanız değerlendirilir.",
  "tour.geo.s4.title": "3) Sonucu okuyun ve aksiyon alın",
  "tour.geo.s4.body": "Genel skor, alt skorlar, kritik bulgular, hızlı kazanımlar ve 30/60/90 gün yol haritası alacaksınız. Sonucu e-posta ile de gönderebilirsiniz.",

  // Competitor Radar tour
  "tour.competitor.s1.title": "Rakip Radarı'na hoş geldiniz",
  "tour.competitor.s1.body": "Trendyol, Hepsiburada, Amazon, Shopify gibi platformlardaki rakiplerinizi anonim olarak karşılaştırın. Boşlukları ve fırsatları görün.",
  "tour.competitor.s2.title": "1) Platform ve kendi verinizi girin",
  "tour.competitor.s2.body": "Üzerinde rekabet ettiğiniz platformu seçin. Mağaza adınız, ortalama puan, ürün sayısı, fiyat ve takipçi gibi temel metriklerinizi yazın.",
  "tour.competitor.s3.title": "2) Rakip mağaza(lar)ı ekleyin",
  "tour.competitor.s3.body": "Rakibinizin temel metriklerini (puan, ürün sayısı, ortalama fiyat, mağaza yaşı vb.) girin. Daha fazla rakip daha kaliteli analiz demek.",
  "tour.competitor.s4.title": "3) AI özet, ödevler ve yol haritası",
  "tour.competitor.s4.body": "Win/Lose/Tie tablosu, güçlü/zayıf yönler, tehdit seviyesi, acil ödevler ve 30/60/90 günlük plan elde edersiniz.",

  // Report Analytics tour
  "tour.analytics.s1.title": "Rapor Analitik'e hoş geldiniz",
  "tour.analytics.s1.body": "Marketplace satıcı panelinizden (Trendyol, Hepsiburada, Amazon, Shopify…) indirdiğiniz raporları yapay zekâya yorumlatın. Veriler şifrelenir ve saklanmaz.",
  "tour.analytics.s2.title": "1) Platformu seçin",
  "tour.analytics.s2.body": "Hangi marketplace'ten geldiğini seçin. AI, platforma özel metrikleri (komisyon, iade oranı, ortalama sepet…) anlayarak yorumlar.",
  "tour.analytics.s3.title": "2) Raporu yükleyin veya yapıştırın",
  "tour.analytics.s3.body": "CSV/XLSX dosyalarını sürükleyip bırakın ya da tabloyu kopyalayıp metin alanına yapıştırın. 8.000 karaktere kadar veri işlenir.",
  "tour.analytics.s4.title": "3) Anlık AI içgörüsü ve ödev listesi",
  "tour.analytics.s4.body": "Kategori dağılımı, kampanya ROI'leri, müşteri profili, kritik uyarılar ve önceliklendirilmiş ödev listenizi alırsınız.",

  // Pricing Engine tour
  "tour.pricing.s1.title": "Fiyatlama Motoru'na hoş geldiniz",
  "tour.pricing.s1.body": "Maliyet, platform komisyonu, kargo ve hedef kâr marjınızı girin; tüm marketplace'ler için tavsiye satış fiyatlarını anında hesaplayın.",
  "tour.pricing.s2.title": "1) Maliyetlerinizi girin",
  "tour.pricing.s2.body": "Birim maliyet, kargo ücreti, paketleme ve KDV bilgilerini girin. Para birimini de seçtiğinizden emin olun (TRY/USD/EUR).",
  "tour.pricing.s3.title": "2) Hedef kâr marjınızı belirleyin",
  "tour.pricing.s3.body": "% olarak hedef brüt marjınızı girin. Bu, fiyat hesaplamasının ana çıpasıdır. %30 sektör ortalaması iyi bir başlangıç noktasıdır.",
  "tour.pricing.s4.title": "3) Platform bazlı tavsiye fiyatları",
  "tour.pricing.s4.body": "Trendyol, Hepsiburada, Amazon, Etsy, Shopify… her platform için ayrı tavsiye satış fiyatı, net gelir ve kâr marjı tablosu görürsünüz.",
};

export default tr;
